import { AccessLevelModel } from '../model/types';
import { getAccessLevelLabel } from './getAccessLevelLabel';

export function accessLevelModelToValueWithLabel(
  accessLevel: AccessLevelModel
): { value: AccessLevelModel; label: string } {
  return {
    value: accessLevel,
    label: getAccessLevelLabel(accessLevel),
  };
}
